import { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Splash, useAuth } from '@mobi/web';
import { Auth } from './pages/Auth.js';
import { Queue } from './pages/Queue.js';
import { Live } from './pages/Live.js';
import { History } from './pages/History.js';
import { Users } from './pages/Users.js';
import { Finance } from './pages/Finance.js';
import { Audit } from './pages/Audit.js';
import { Shell } from './components/Shell.js';

export function App() {
  const { user, loading } = useAuth();
  const [splashDone, setSplashDone] = useState(false);

  if (!splashDone) {
    return (
      <Splash
        role="Administração"
        tagline="Fila, corridas, financeiro"
        ready={!loading}
        onFinished={() => setSplashDone(true)}
      />
    );
  }

  if (!user) return <Auth />;

  return (
    <Routes>
      <Route element={<Shell />}>
        <Route path="/" element={<Navigate to="/fila" replace />} />
        <Route path="/fila" element={<Queue />} />
        <Route path="/ao-vivo" element={<Live />} />
        <Route path="/historico" element={<History />} />
        <Route path="/usuarios" element={<Users />} />
        <Route path="/financeiro" element={<Finance />} />
        <Route path="/auditoria" element={<Audit />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
